<app-page-header title="Outgoing transport locations">
    <div class="btn-group">
        <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        <app-change-log-link *bizPermissionRequired="'Transport_View_OutgoingLocation_Log'" [title]="'Outgoing transport locations log'">
            <app-change-log-link-entity type="TransportOutConfiguration"></app-change-log-link-entity>
        </app-change-log-link>
    </div>
</app-page-header>


<div class="btn-toolbar mb-2">
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_View_OutgoingLocation_Details'" [disabled]="!canViewLocations()"
            (click)="viewLocations(selectedLocations())">Show locations</button>
    </div>
    <div class="btn-group">
        <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_Action_OutgoingLocation_Export'"
            [disabled]="!canExportLocations()" (click)="exportLocations(selectedLocations())">Export</button>
    </div>
    @if (hasblockedLocations()) {
        <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_Action_OutgoingLocation_Unblock'"
                [disabled]="!canUnblockLocations()" (click)="unblockLocations(selectedLocations())">Unblock</button>
        </div>
    }
    @if(transportOutOverrideId() >= 0) {
        <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm" *bizPermissionRequired="'Transport_Action_OutgoingLocation_Override'" (click)="overrideLocations()">
                @if (transportOutOverrideId() > 0) {
                    <span>Change override location</span>
                }
                @else {
                    <span>Override all locations</span>
                }
            </button>
        </div>
    }
    @if (restricted()) {
        <restricted-search-callout [visible]="true" text="The list is limited by datagroup access restrictions.">
        </restricted-search-callout>
        <div class="clearfix"></div>
    }
</div>

<app-transport-out-locations-grid [locations]="locations()" [partners]="partners()" [partnerSystems]="partnerSystems()" [transportTypes]="transportTypes()"
    (selectionChanged)="selectionChanged($event)" [allowManageGlobal]="allowManageGlobal" [allowViewing]="allowViewing" (viewLocation)="viewLocation($event)"
    [allowAdding]="allowAdding" (addLocation)="addLocation()" [allowCopying]="allowCopying" (copyLocation)="copyLocation($event)"
    [allowDeleting]="allowDeleting" [allowShowLog]="allowShowLog" (deleteLocation)="deleteLocation($event)">
</app-transport-out-locations-grid>
